import i18next from 'i18next';

import ColumnFilterMultiSelect from '../../../../VehicleTable/components/filters/ColumnFilterMultiSelect';
import ColumnFilterInput from '../../../../VehicleTable/components/filters/ColumnFilterInput';
import ColumnFilterDoubleInput from '../../../../VehicleTable/components/filters/ColumnFilterDoubleInput';
import filterFn from '../../../../VehicleTable/customFilterFn';

export const columnsPudLogs = [
  {
    accessor: 'logId',
    id: 'logId',
    Header: i18next.t('log_id'),
    disableSortBy: true,
    width: 60,
  },
  {
    accessor: 'created_at',
    id: 'created_at',
    Header: i18next.t('created_at'),
    inputType: 'date',
    PrimaryFilter: ColumnFilterDoubleInput,
    filter: filterFn,
    width: 180,
  },
  {
    accessor: 'operator',
    id: 'operator',
    Header: i18next.t('operator'),
    PrimaryFilter: ColumnFilterInput,
    filter: filterFn,
    width: 260,
  },
  {
    accessor: 'description',
    id: 'description',
    Header: i18next.t('action'),
    PrimaryFilter: ColumnFilterMultiSelect,
    filter: filterFn,
    width: 280,
  },
  {
    accessor: 'licensePlate',
    id: 'licensePlate',
    Header: i18next.t('license_plate'),
    width: 130,
  },
];
